<template>
  <div id="app">
    <div id="app"><div id="Scatter" class="Scatter"></div></div>
  </div>
</template>
    
    <script>
import * as echarts from "echarts";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Scatter",
  data() {
    return {
      data0: [],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
    };
  },
  methods: {
    async initChart() {
      this.char = echarts.init(document.getElementById("Scatter"), null, {  
        renderer: "svg",
      });
      this.char.setOption({
        backgroundColor: "white",
        title: {
          text: "",
          subtext: "",
        },
        grid: {
          left: "2%",
          right: "9%",
          bottom: "18%",
          top: "7%",
          containLabel: true,
        },
        tooltip: {
          // trigger: 'axis',
          trigger: "item",
          showDelay: 0,
          formatter: function (params) {
            if (params.value.length > 1) {
              return (
                params.seriesName +
                " <br/><i>" +
                params.value[2] +
                "</i> <br/>GC: " +
                params.value[0] +
                "% <br/>size: " +
                params.value[1].toLocaleString() +
                " bp "
              );
            } else if (params.componentType == "markPoint") {
              return (
                params.name + " <br/> " + params.value.toLocaleString() + " bp"
              );
            } else if (params.componentType == "markLine") {
              return (
                params.name + " <br/> " + params.value.toLocaleString() + " %"
              );
            }
          },
          axisPointer: {
            show: true,
            type: "cross",
            lineStyle: {
              type: "dashed",
              width: 1,
            },
          },
        },
        dataZoom: [
          {
            type: "slider",
            xAxisIndex: 0, // 指定控制的 x 轴
            start: 10, // 设置默认缩放区域的起始百分比
            end: 80, // 设置默认缩放区域的结束百分比
            bottom: "9%",
            handleSize: "70%", // 调整滑块大小
            handleStyle: {
              color: "white", // 调整滑块颜色

              shadowOffsetX: 1,
              shadowOffsetY: 1,
            },
          },

          {
            type: "slider",
            yAxisIndex: 0, // 指定控制的 x 轴
            start: 0, // 设置默认缩放区域的起始百分比
            end: 30, // 设置默认缩放区域的结束百分比
            bottom: "9%",
            handleSize: "70%", // 调整滑块大小
            handleStyle: {
              color: "white", // 调整滑块颜色

              shadowOffsetX: 1,
              shadowOffsetY: 1,
            },
          },
        ],
        toolbox: {
          feature: {
            // brush: {
            //   type: ["rect", "polygon", "clear"],
            //   title: {
            //     rect: "Box Select",
            //     polygon: "Lasso Select",
            //     clear: "Clear Selections",
            //   },
            // },
            saveAsImage: {
              show: true,
              title: "Download",
              type: "png",
              name: "Scatter",
            },
          },
        },

        legend: {
          left: "center",
          bottom: 1,
        },
        xAxis: [
          {
            name: "\n\nGC",
            nameLocation: "start", // 将名称移到中间
            nameGap: 30, // 调整名称与坐标轴的距离，防止和刻度标签重叠
            nameTextStyle: {
              fontSize: 16,
              fontWeight: "bold",
              lineHeight: 14
            },
            type: "value",
            scale: true,
            axisLabel: {
              formatter: "{value}%",
            },
            splitLine: {
              show: true, // 显示网格线
              lineStyle: {
                type: "dashed", // 网格线为虚线
                color: "#aaa", // 网格线颜色
              },
            },
          },
        ],
        yAxis: [
          {
            name: "Genome size",
            nameLocation: "end", // 将名称移到中间
            nameGap: 10, // 调整名称与坐标轴的距离，防止和刻度标签重叠
            nameTextStyle: {
              fontSize: 16,
              fontWeight: "bold",
              padding: [0, 0, 0, -80]
            },
            type: "value",
            scale: true,

            splitLine: {
              show: false,
            },
            axisLabel: {
              // 使用formatter函数自定义轴标签的显示
              formatter: function (value) {
                // 根据数值的大小添加相应的单位

                return (value / 1000).toLocaleString() + " Kb";
              },
            },
          },
        ],
      });
      await this.$axios.get("api/api.echarts/scatter_plot").then((res) => {
        this.data0 = res.data.data[0].data;
        this.data1 = res.data.data[1].data;
        this.data2 = res.data.data[2].data;
        this.data3 = res.data.data[3].data;
        this.data4 = res.data.data[4].data;
        this.char.setOption({
          series: [
            {
              name: "Angiosperms",
              type: "scatter",
              emphasis: {
                focus: "series",
              },
              data: this.data0,
              // markArea: {
              //   silent: true,
              //   itemStyle: {
              //     color: "transparent",
              //     borderWidth: 1,
              //     borderType: "dashed",
              //   },
              //   data: [
              //     [
              //       {
              //         name: "Angiosperm Data Range",
              //         xAxis: "min",
              //         yAxis: "min",
              //       },
              //       {
              //         xAxis: "max",
              //         yAxis: "max",
              //       },
              //     ],
              //   ],
              // },
              // markPoint: {
              //   data: [
              //     { type: "max", name: "Angiosperm<br/>Max" },
              //     { type: "min", name: "Angiosperm<br/>Min" },
              //   ],
              // },
              // markLine: {
              //   lineStyle: {
              //     type: "solid",
              //   },
              //   data: [
              //     { type: "average", name: "Angiosperm<br/>AVG" },
              //     { xAxis: 45, name: "Angiosperm" },
              //   ],
              // },
            },
            {
              name: "Gymnosperms",
              type: "scatter",
              emphasis: {
                focus: "series",
              },
              data: this.data1,
              // markArea: {
              //   silent: true,
              //   itemStyle: {
              //     color: "transparent",
              //     borderWidth: 1,
              //     borderType: "dashed",
              //   },
              //   data: [
              //     [
              //       {
              //         name: "Gymnosperm Data Range",
              //         xAxis: "min",
              //         yAxis: "min",
              //       },
              //       {
              //         xAxis: "max",
              //         yAxis: "max",
              //       },
              //     ],
              //   ],
              // },
              // markPoint: {
              //   data: [
              //     { type: "max", name: "Gymnosperm<br/>Max" },
              //     { type: "min", name: "Gymnosperm<br/>Min" },
              //   ],
              // },
              // markLine: {
              //   lineStyle: {
              //     type: "solid",
              //   },
              //   data: [
              //     { type: "average", name: "Gymnosperm<br/>AVG" },
              //     { xAxis: 45, name: "Gymnosperm" },
              //   ],
              // },
            },
            {
              name: "Bryophytes",
              type: "scatter",
              emphasis: {
                focus: "series",
              },
              data: this.data2,
              // markArea: {
              //   silent: true,
              //   itemStyle: {
              //     color: "transparent",
              //     borderWidth: 1,
              //     borderType: "dashed",
              //   },
              //   data: [
              //     [
              //       {
              //         name: "Bryophyte Data Range",
              //         xAxis: "min",
              //         yAxis: "min",
              //       },
              //       {
              //         xAxis: "max",
              //         yAxis: "max",
              //       },
              //     ],
              //   ],
              // },
              // markPoint: {
              //   data: [
              //     { type: "max", name: "Bryophyte<br/>Max" },
              //     { type: "min", name: "Bryophyte<br/>Min" },
              //   ],
              // },
              // markLine: {
              //   lineStyle: {
              //     type: "solid",
              //   },
              //   data: [
              //     { type: "average", name: "Bryophyte<br/>AVG" },
              //     { xAxis: 45, name: "Bryophyte" },
              //   ],
              // },
            },
            {
              name: "Algae",
              type: "scatter",
              emphasis: {
                focus: "series",
              },
              data: this.data3,
              // markArea: {
              //   silent: true,
              //   itemStyle: {
              //     color: "transparent",
              //     borderWidth: 1,
              //     borderType: "dashed",
              //   },
              //   data: [
              //     [
              //       {
              //         name: "Phycophyta Data Range",
              //         xAxis: "min",
              //         yAxis: "min",
              //       },
              //       {
              //         xAxis: "max",
              //         yAxis: "max",
              //       },
              //     ],
              //   ],
              // },
              // markPoint: {
              //   data: [
              //     { type: "max", name: "Phycophyta<br/>Max" },
              //     { type: "min", name: "Phycophyta<br/>Min" },
              //   ],
              // },
              // markLine: {
              //   lineStyle: {
              //     type: "solid",
              //   },
              //   data: [
              //     { type: "average", name: "Phycophyta<br/>AVG" },
              //     { xAxis: 45, name: "Phycophyta" },
              //   ],
              // },
            },
            {
              name: "Pteridophytes",
              type: "scatter",
              emphasis: {
                focus: "series",
              },
              data: this.data4,
              // markArea: {
              //   silent: true,
              //   itemStyle: {
              //     color: "transparent",
              //     borderWidth: 1,
              //     borderType: "dashed",
              //   },
              //   data: [
              //     [
              //       {
              //         name: "Pteridophyte Data Range",
              //         xAxis: "min",
              //         yAxis: "min",
              //       },
              //       {
              //         xAxis: "max",
              //         yAxis: "max",
              //       },
              //     ],
              //   ],
              // },
              // markPoint: {
              //   data: [
              //     { type: "max", name: "Pteridophyte<br/>Max" },
              //     { type: "min", name: "Pteridophyte<br/>Min" },
              //   ],
              // },
              // markLine: {
              //   lineStyle: {
              //     type: "solid",
              //   },
              //   data: [
              //     { type: "average", name: "Pteridophyte<br/>AVG" },
              //     { xAxis: 45, name: "Pteridophyte" },
              //   ],
              // },
            },
          ],
        });
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
};
</script>
    <style>
.Scatter {
  margin: 30px 10px;
  width: 840px;
  height: 360px;
  background-color: rgb(252, 250, 250);
  border-radius: 40px;
}
</style>